import { Button, LinkButton } from '@cian/ui-kit/button';
import { FC } from 'react';

import { QUALITY_OF_SERVICE_URL } from 'shared/containers/Superhost/const';

import logo from '../assets/logo-cian.svg';
import whiteLogo from '../assets/logo-cian-white.svg';
import style from './Header.css';
import { useDeviceType } from '@cian/ui-kit';

interface IHeaderProps {
  isAuthDisabled: boolean;
  onAuthClick: () => void;
}

export const Header: FC<IHeaderProps> = ({ isAuthDisabled, onAuthClick }) => {
  const isMobile = useDeviceType() === 'phone';

  return (
    <header className={style['header']}>
      <div className={style['inner']}>
        <img className={style['logo']} src={isMobile ? whiteLogo : logo} alt="" />
        <div className={style['buttons']}>
          <LinkButton theme="stroke_primary" size="L" href={QUALITY_OF_SERVICE_URL}>
            Проверить свой уровень
          </LinkButton>
          <Button theme="fill_primary" size="L" disabled={isAuthDisabled} onClick={onAuthClick}>
            Войти
          </Button>
        </div>
      </div>
    </header>
  );
};
